module.exports = __webpack_public_path__ + "img/settings/CloudFront.fc7f70.svg";